import { DateTime } from "luxon"
import { FaExternalLinkAlt, FaRegImage } from "react-icons/fa"
import { NeutralButton } from "../../common/Buttons"

export default function UnitFilesRow({ file }) {
  const metaLine = DateTime.fromISO(file.attributes['created-at']).toLocaleString()
  const isPhoto = !!file.attributes.photo

  return (
    <div className="flex w-full py-2 px-2 lg:hover:bg-grey-700 text-grey-300 text-left border-b-2 border-grey-700">
      <div className="flex flex-col w-full" data-testid="unit-file-row">
        <div className="flex w-full items-center justify-between text-grey-100">
          <div className="flex flex-col w-1/2 md:w-2/3">
            <div className="text-sm">{metaLine}</div>
            <div className="flex items-center gap-2 font-bold text-lg text-grey-100 text-ellipsis overflow-hidden whitespace-nowrap">
              {isPhoto && <FaRegImage className="shrink-0 text-grey-300" data-testid="unit-file-photo-icon" />}
              {file.attributes.name}
            </div>
          </div>
          <div className="flex align-middle justify-end w-1/2 md:w-1/3">
            <NeutralButton
              text={<span className="flex items-center gap-2">Open File <FaExternalLinkAlt /></span>}
              onClick={() => window.open(file.attributes.url, '_blank')}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
